export default __webpack_public_path__ + "static/media/OliviaMeower.46e44a19.jpeg";